import ReactDOM from 'react-dom/client'
import App from './App'
import '../styles/main.css'
import './styles/index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <App />,
)
